import React from "react";
import PropTypes from "prop-types";
import { Modal, Form, Button, Spinner } from "react-bootstrap";
import ColorPicker from "./ColorPicker";

const FormStatusModal = ({
    show,
    onHide,
    onSave,
    editId,
    saving,
    error,
    form,
    onChange,
    validationErrors,
    colors,
    onColorPick,
}) => {
    return (
        <Modal show={show} onHide={onHide} backdrop="static" centered size="lg">
            <Form onSubmit={onSave} noValidate>
                <Modal.Header closeButton={!saving}>
                    <Modal.Title>{editId ? "Edit Status" : "Add Status"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && (
                        <div className="alert alert-danger py-2" role="alert">
                            {error}
                        </div>
                    )}
                    <Form.Group className="mb-3">
                        <Form.Label>
                            Name <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            name="Name"
                            value={form.Name}
                            onChange={onChange}
                            placeholder="Enter status name"
                            autoFocus
                            isInvalid={!!validationErrors.Name}
                        />
                        <Form.Control.Feedback type="invalid">
                            {validationErrors.Name}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            name="Description"
                            value={form.Description}
                            onChange={onChange}
                            placeholder="Optional description"
                        />
                    </Form.Group>
                    <Form.Group>
                        <div className="row col-12 mb-2">
                            <Form.Label>
                                Badge Color <span className="text-danger">*</span>
                            </Form.Label>
                        </div>

                        <div className="row col-12 mb-2">
                            <ColorPicker
                                colors={colors}
                                selected={form.BadgeColorName}
                                onPick={onColorPick}
                                hasError={!!validationErrors.BadgeColorName}
                            />
                        </div>
                        {validationErrors.BadgeColorName && (
                            <div className="row col-12 text-danger">
                                {validationErrors.BadgeColorName}
                            </div>
                        )}
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className="justify-content-start">
                    <Button variant="outline-secondary" onClick={onHide} disabled={saving}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary" disabled={saving} className="ms-2">
                        {saving ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" /> Saving...
                            </>
                        ) : editId ? "Update" : "Create"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

FormStatusModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    editId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    saving: PropTypes.bool,
    error: PropTypes.string,
    form: PropTypes.shape({
        Name: PropTypes.string,
        Description: PropTypes.string,
        BadgeColorName: PropTypes.string,
        BadgeColorId: PropTypes.number,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    validationErrors: PropTypes.shape({
        Name: PropTypes.string,
        BadgeColorName: PropTypes.string,
    }),
    colors: PropTypes.array.isRequired,
    onColorPick: PropTypes.func.isRequired,
};

FormStatusModal.defaultProps = {
    editId: null,
    saving: false,
    error: "",
    validationErrors: {},
};

export default FormStatusModal;
